<section role="dialog" aria-modal="true" aria-labelledby="Vat-title">
  @if(isLoader) {
    <div class="fixed inset-0 bg-opacity-50 backdrop-blur-sm flex items-center justify-center" style="z-index: 999"
      role="status" aria-live="polite" aria-label="Loading">
      <mat-progress-spinner class="!h-[50px] !w-[50px]" mode="indeterminate" />
    </div>
  }
  <div>
    <form #editProfile="ngForm" class="flex flex-col gap-[3rem] p-[1.25rem]" (ngSubmit)="setVatNumber()">
      <fieldset>
        <legend class="sr-only">VAT form</legend>
        <div class="flex flex-col gap-[0.8rem]">
          <h2 mat-dialog-title id="vat-title" class="!min-h-fit">
            {{ "REGISTRATION_LABEL_VAT" | translate }}<span class="req-label">&nbsp;*</span>
          </h2>
          <div class="w-full min-w-0 px-[25px] flex flex-wrap items-center gap-[0.4rem]">
            <span class="showVatInfo vat-click-label min-w-0 break-words">
              {{ "REG_CLICK_LABEL" | translate }}
            </span>
            <span class="inline-flex shrink-0 items-center">
              <dsr-icon name="refresh" class="!size-[2.4rem]" aria-hidden="true"></dsr-icon>
            </span>
            <span class="min-w-0 break-words">{{ "REG_VERIFY_VAT_NUMBER" | translate }}</span>
          </div>
        </div>
        <mat-dialog-content class="!w-[35rem] !h-[11rem]">
          <div class="pt-2 mt-2">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{ 'REGISTRATION_LABEL_VAT' | translate }}</mat-label>
              <input matInput type="text" [(ngModel)]="vatValue" id="vatValue" name="vatValue" #vatModel="ngModel"
                maxlength="15" required autocomplete="off" pattern="^[a-zA-Z0-9]+$"
                placeholder="{{ 'VAT_PLACEHOLDER' | translate }}" (ngModelChange)="vatNumberChanged()" />
              <dsr-icon matSuffix [ngClass]="{ '!bg-[lawngreen]': vatVerified, '!bg-[#000000]': !vatVerified }"
                class="cursor-pointer" [name]="vatVerified ? 'confirm-2' : 'refresh'" alt="VAT verify"
                (click)="validateVAT()" matTooltip="verify VAT number">
              </dsr-icon>
              <mat-hint>{{ "VAT_SAMPLE" | translate }}</mat-hint>
              @if(vatModel.errors && vatModel.touched) {
                <mat-error class="p-[2rem]">Enter valid VAT number</mat-error>
              }
            </mat-form-field>
            @if(showVATError) {
              <div class="error-span !text-red-500 !font-[600] dsr-typescale-body-small min-h-[2.2rem] !text-wrap p-[2rem]">
                {{ "REGISTRATION_VAT_ERROR" | translate }}
              </div>
            }
            @if(vatServiceDown) {
              <div class="error-span !text-red-500 !font-[600] dsr-typescale-body-small min-h-[2.2rem] !text-wrap p-[2rem]">
                {{ "VAT_SERVICE_DOWN_MSG" | translate }}
              </div>
            }
          </div>
        </mat-dialog-content>
        <mat-dialog-actions role="group" aria-label="Address form actions" class="">
          <div class="">
            <button mat-flat-button class="" type="submit" [attr.aria-busy]="isLoader"
              [disabled]="editProfile.invalid || !editProfile.dirty || showVATError || !vatVerified">
              <span class="">{{ "CONFIRM_BUTTON" | translate }}</span>
            </button>
            <button mat-stroked-button color="primary" class="" type="button" (click)="closeVatPopUp()"
              aria-label="Cancel and return">
              <span class="">{{ "CANCEL_BUTTON" | translate }}</span>
            </button>
          </div>
        </mat-dialog-actions>
      </fieldset>
    </form>
  </div>
</section>